window.portalModule.controller 'PastAppointmentsController', ($scope, $state, $stateParams, $log, AuthService, FeedItemService) ->
  $log = $log.getInstance('PastAppointmentsController')
  $log.log 'past appointments controller loaded.'
  $scope.hasDownloadAndTransmitLinks = false
  $scope.customPageHeader = 'Appointments'
  $scope.filter = 'past'

  # listen for an event to refresh the feed items (reload the data)
  $scope.$on 'fetch-feed-items', (event, payload) ->
    $log.log event
    $scope.init()

  $scope.init = ->
    FeedItemService.past().then (response) ->
      $scope.appointmentFeed = response.data
      $log.log '$scope.appointments', $scope.appointmentFeed

    FeedItemService.getStates('past').then (response) ->
      $scope.states = response

  $scope.init()